module.exports = __webpack_public_path__ + "img/bg.b57f6380.png";